var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSculpture = function SvgSculpture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#461B14",
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.25,
    d: "M14.375 29.375h11.25m-9.122-.285v-3.71h6.69v3.71m-1.53-3.71.01-3.994.912-.856v-1.696c0-1.427-1.226-2.584-2.737-2.584s-2.736 1.157-2.736 2.584v1.696l.912.856-.01 3.994m3.971-12.88c0 1.036-.889 1.875-1.985 1.875s-1.985-.84-1.985-1.875.889-1.875 1.985-1.875 1.985.84 1.985 1.875Z"
  })));
};
export default SvgSculpture;